import t from"react";import a from"../../utils/classnames.js";import e from"../Status/Status.js";const s=({iconColor:s,label:o,className:r})=>t.createElement("div",{className:a("perxis-auto-car-tile-status",r)},t.createElement(e,{iconColor:s},o));export{s as default};
//# sourceMappingURL=CarTileStatus.js.map
